import {Meta} from '@rdcomponents/meta/meta';
import {PageHeaderTitle} from '@rdcomponents/page-header-title/page-header-title';
import {Tabs} from 'antd';
import {useState} from 'react';

import {appRoute} from '../../../../../app-route';
import {BreadCrumbs} from '../../../../../layout/bread-crumbs/bread-crumbs';
import {Page} from '../../../../../layout/page/page';
import {MainPageContainer} from '../../../../../layout/page-card/main-page-container';
import {PageCard} from '../../../../../layout/page-card/page-card';
import {PageHeader} from '../../../../../layout/page-header/page-header';
import {Locale} from '../../../../../provider/locale/locale';
import {useLocale} from '../../../../../provider/locale/locale-hook';
import {getEnumValueEnsure} from '../../../../../util/enum';
import {useUrl} from '../../../../../util/url-hook/url-hook';

import {AspectsTab} from './aspects-tab/aspects-tab';
import {KeywordsAndTopicsForm} from './keywords-and-topics-form/keywords-and-topics-form';
import {KeywordsAndTopicsPageProvider} from './keywords-and-topics-page-context';
import {KeywordsAndTopicsTabsEnum} from './keywords-and-topics-page-type';
import {KeywordsTab} from './keywords-tab/keywords-tab';
import {TopicsTab} from './topics-tab/topics-tab';
import {UserTagsTab} from './user-tags-tab/user-tags-tab';
import * as styles from './keywords-and-topics-page.scss';

export function KeywordsAndTopicsPage(): JSX.Element {
    const {queries} = useUrl();

    const [activeTab, setActiveTab] = useState(() => {
        return getEnumValueEnsure(KeywordsAndTopicsTabsEnum, queries.mode, KeywordsAndTopicsTabsEnum.Keywords);
    });

    const {reviewsAnalysisDashboard: dashboardRoute, reviewsAnalysisKeywordsAndTopics: tagsRoute} = appRoute;

    const {getLocalizedString} = useLocale();

    return (
        <Page renderContainer={(children) => <MainPageContainer>{children}</MainPageContainer>}>
            <PageCard>
                <Meta title={getLocalizedString('CATEGORY_NAME__REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS')} />

                <BreadCrumbs
                    list={[
                        {
                            path: dashboardRoute.path,
                            titleLangKey: 'CATEGORY_NAME__REVIEWS_ANALYSIS',
                        },
                        {
                            path: tagsRoute.path,
                            titleLangKey: 'CATEGORY_NAME__REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS',
                        },
                    ]}
                />

                <PageHeader>
                    <PageHeaderTitle title="CATEGORY_NAME__REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS" />
                </PageHeader>
            </PageCard>

            <KeywordsAndTopicsPageProvider>
                <>
                    <PageCard className={styles.FiltersPageCard}>
                        <Tabs
                            activeKey={activeTab}
                            onChange={(tabKey) =>
                                setActiveTab(
                                    getEnumValueEnsure(
                                        KeywordsAndTopicsTabsEnum,
                                        tabKey,
                                        KeywordsAndTopicsTabsEnum.Keywords
                                    )
                                )
                            }
                        >
                            <Tabs.TabPane
                                key={KeywordsAndTopicsTabsEnum.Keywords}
                                tab={<Locale stringKey="REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS_TAB_KEYWORDS" />}
                            />

                            <Tabs.TabPane
                                key={KeywordsAndTopicsTabsEnum.Topics}
                                tab={<Locale stringKey="REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS_TAB_TOPICS" />}
                            />

                            <Tabs.TabPane
                                key={KeywordsAndTopicsTabsEnum.Aspects}
                                tab={<Locale stringKey="REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS__ASPECTS_TITLE" />}
                            />
                            <Tabs.TabPane
                                key={KeywordsAndTopicsTabsEnum.UserTags}
                                tab={<Locale stringKey="REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS__USER_TAGS_TITLE" />}
                            />
                        </Tabs>

                        <KeywordsAndTopicsForm
                            activeTab={activeTab}
                            isCompareRangeAllowed={activeTab === KeywordsAndTopicsTabsEnum.Aspects}
                            isTopicsAllowed={activeTab === KeywordsAndTopicsTabsEnum.Topics}
                        />
                    </PageCard>

                    {activeTab === KeywordsAndTopicsTabsEnum.Keywords && <KeywordsTab />}
                    {activeTab === KeywordsAndTopicsTabsEnum.Topics && <TopicsTab />}
                    {activeTab === KeywordsAndTopicsTabsEnum.Aspects && <AspectsTab />}
                    {activeTab === KeywordsAndTopicsTabsEnum.UserTags && <UserTagsTab />}
                </>
            </KeywordsAndTopicsPageProvider>
        </Page>
    );
}
